@if (this.ruleDetails != null) {
  <div class="automation-rules">
    <sc-master-detail [selection]="[selectedRule]" [data]="rules" (selectionChanged)="onSelectionChanged($event);"
      (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);" [newStyle]="true">
      <div class="automation-rule-details">
        <div class="form-box" [formGroup]="detailsForm">
          <sc-flex vertical stretchContent>
            <mat-form-field appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.automation-rules.index"></sc-dictionary-label>
              </mat-label>
              <input matInput appPositiveInteger type="number" min="0" name="index" formControlName="index"
                [required]="true" [maxLength]="255">
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.automation-rules.name"></sc-dictionary-label>
                </mat-label>
                <input matInput name="name" formControlName="name" [required]="true" [maxLength]="255">
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.common.type"></sc-dictionary-label>
                </mat-label>
                <mat-select name="type" formControlName="type" required>
                  @for (typeOption of automationRuleTypeOptions; track typeOption) {
                    <mat-option [value]="typeOption">
                      <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.admin.automation-rules.automation-type.{{typeOption}}"></sc-dictionary-label>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (this.ruleDetails.type === automationRuleType.ASSIGNMENT) {
                <mat-checkbox formControlName="onlyPlanned"
                  name="onlyPlanned">
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.automation-rules.only-planned"></sc-dictionary-label>
                </mat-checkbox>
              }
              <sc-flex>
                @if (this.ruleDetails.type === automationRuleType.ASSIGNMENT) {
                  <mat-radio-group formControlName="executionStrategy">
                    <mat-radio-button value="immediate"><sc-dictionary-label dictionaryKey="tmc-yard.entity.automation-rule.execute-assignment-immediate"></sc-dictionary-label></mat-radio-button>
                    <mat-radio-button value="delayed"><sc-dictionary-label dictionaryKey="tmc-yard.entity.automation-rule.execute-assignment-delayed"/></mat-radio-button>
                    <mat-radio-button value="plan"><sc-dictionary-label dictionaryKey="tmc-yard.entity.automation-rule.plan-assignment"/></mat-radio-button>
                  </mat-radio-group>
                }
                <sc-content-spacer/>
                @if (this.ruleDetails.type === automationRuleType.ASSIGNMENT) {
                  <sc-number-field formControlName="preExecutionOffset" labelDictionaryKey="tmc-yard.entity.automation-rule.preExecutionOffset"></sc-number-field>
                }
              </sc-flex>
              @if (!(this.ruleDetails.type === automationRuleType.ASSIGNMENT &&  this.ruleDetails.onlyPlanned)) {
                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label
                    dictionaryKey="tmc-yard.ui.admin.automation-rules.number-plate"></sc-dictionary-label>
                  </mat-label>
                  <input matInput name="numberPlate" formControlName="numberPlate" [required]="false" [maxLength]="255">
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.automation-rules.carrier"></sc-dictionary-label>
                  </mat-label>
                  <input matInput name="carrier" formControlName="carrier" [required]="false" [maxLength]="255">
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>
                    <sc-dictionary-label
                    dictionaryKey="tmc-yard.ui.admin.automation-rules.order-reference"></sc-dictionary-label>
                  </mat-label>
                  <input matInput name="orderReference" formControlName="orderReference" [required]="false"
                    [maxLength]="255">
                  </mat-form-field>
                }
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-sub-title>
                  <sc-dictionary-label
                  dictionaryKey="tmc-yard.ui.admin.automation-rules.assigned-stations.title"></sc-dictionary-label>
                </sc-sub-title>
                <div class="rule-station-assignment">
                  <div class="rule-stations-list" style="grid-column: 1; grid-row:  2;" cdkDropList
                    cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropAssignmentRuleStation($event)">
                    @for (station of getStationsOfRule(); track station) {
                      <div class="rule-station" cdkDrag>
                        {{station.name}}
                        <i (click)="removeStationFromStationAssignmentRule(station)"
                        class="cursor-pointer fa-light fa-times"></i>
                      </div>
                    }
                  </div>
                  <sc-add-action-button large style="grid-column: 2; grid-row:  2;"
                  (click)="addStationToStationAssignmentRule()"></sc-add-action-button>
                </div>
                @if (showStationsError) {
                  <div class="configChangedText">
                    <div class="validation-error">
                      <sc-dictionary-label
                      dictionaryKey="tmc-yard.ui.admin.automation-rules.validation-error.rules.invalid-station"></sc-dictionary-label>
                    </div>
                  </div>
                }
              </sc-flex>
            </div>
          </div>
          <ng-template masterDetailToolbar>
            <sc-cancel-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled"></sc-cancel-button>
            <div class="spacer"></div>
            <sc-content-spacer></sc-content-spacer>
            <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>
          </ng-template>
        </sc-master-detail>
      </div>
    }
